export default "__VITE_ASSET__rLk655et__"